import barba from '@barba/core';
import views from './views/views';
import transitions from './transitions/transitions';

export default class Spa {
	constructor() {
		if (history.scrollRestoration) {
			history.scrollRestoration = 'manual';
		}

		// Global Barba hooks
		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			next.container.dispatchEvent(
				new CustomEvent('bless', {
					bubbles: true,
					detail: next,
				})
			);
		});

		barba.hooks.leave(({ current, next, trigger }) => {
			document.dispatchEvent(
				new CustomEvent('leave', {
					detail: next,
				})
			);
		});

		// Barba settings, transitions and views
		barba.init({
			debug: window.WPURLS.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				if (/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(href)) {
					return true;
				}
			},
			transitions: transitions,
			views: views,
		});
	}
}
